import React from "react";

const ProcessingControls = ({
  onAutoAllocate,
  onAutoAllocatePending,
  onCheckDuplicates,
  onFindUnallocated,
  onClearAutoAllocation,
  onClearAllColumns,
  onReload,
  onSaveAllocations,
  onDownload,
  onCheckDoc,
  onFixFormat,
  isProcessing,
}) => {
  const ButtonWithSpinner = ({ onClick, disabled, className, children, ...props }) => (
    <button
      onClick={onClick}
      disabled={disabled || isProcessing}
      className={`${className} ${disabled || isProcessing ? "opacity-50 cursor-not-allowed" : ""}`}
      {...props}
    >
      {isProcessing && <div className="spinner"></div>}
      {children}
    </button>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* Auto Allocate Rooms */}
      <div className="space-y-2">
        <h3 className="font-semibold text-gray-700">Room Allocation</h3>
        <ButtonWithSpinner onClick={onAutoAllocate} className="btn btn-primary w-full">
          Auto Allocate Rooms
        </ButtonWithSpinner>
        <ButtonWithSpinner
          onClick={onAutoAllocatePending}
          className="btn btn-primary w-full bg-indigo-600 hover:bg-indigo-700"
        >
          Auto Allocate (Only Pending)
        </ButtonWithSpinner>
        <p className="text-xs text-gray-500">
          Automatically assigns rooms based on student count and availability
        </p>
      </div>

      {/* Analysis Functions */}
      <div className="space-y-2">
        <h3 className="font-semibold text-gray-700">Analysis</h3>
        <div className="space-y-2">
          <ButtonWithSpinner onClick={onCheckDuplicates} className="btn btn-secondary w-full">
            Check Duplicates
          </ButtonWithSpinner>
          <ButtonWithSpinner onClick={onFindUnallocated} className="btn btn-secondary w-full">
            Find Available Rooms
          </ButtonWithSpinner>
        </div>
        <p className="text-xs text-gray-500">Analyze allocation conflicts and available rooms</p>
      </div>

      {/* Course Name Checks */}
      <div className="space-y-2">
        <h3 className="font-semibold text-gray-700">Course Names</h3>
        <div className="space-y-2">
          <ButtonWithSpinner onClick={onCheckDoc} className="btn btn-secondary w-full">
            Check Doc
          </ButtonWithSpinner>
          <ButtonWithSpinner
            onClick={onFixFormat}
            className="btn btn-secondary w-full bg-amber-600 hover:bg-amber-700 text-white"
          >
            Fix Format
          </ButtonWithSpinner>
        </div>
        <p className="text-xs text-gray-500">
          Check Doc only reports. Fix Format rewrites the course names in the file.
        </p>
      </div>

      {/* Clear and Reload Functions */}
      <div className="space-y-2 md:col-span-2 lg:col-span-3">
        <h3 className="font-semibold text-gray-700">Clear &amp; Reload</h3>
        <div className="flex flex-wrap justify-center gap-3">
          <ButtonWithSpinner onClick={onClearAutoAllocation} className="btn btn-danger px-8">
            Clear Auto Allocation
          </ButtonWithSpinner>
          <ButtonWithSpinner onClick={onClearAllColumns} className="btn btn-danger px-8">
            Clear All Analysis
          </ButtonWithSpinner>
          <ButtonWithSpinner onClick={onReload} className="btn btn-primary px-8">
            🔄 Reload from File
          </ButtonWithSpinner>
        </div>
        <p className="text-xs text-gray-500 text-center">
          Reset allocation data and analysis results, or reload everything from the workbook
          as it is saved on disk now
        </p>
      </div>

      {/* Download */}
      <div className="space-y-2 md:col-span-2 lg:col-span-3">
        <h3 className="font-semibold text-gray-700">Export</h3>
        <div className="flex flex-wrap justify-center gap-3">
          <ButtonWithSpinner onClick={onDownload} className="btn btn-success px-8">
            📥 Download Updated Excel File
          </ButtonWithSpinner>
          <ButtonWithSpinner
            onClick={onSaveAllocations}
            className="btn btn-success px-8 bg-emerald-700 hover:bg-emerald-800"
          >
            💾 Save All Results into File
          </ButtonWithSpinner>
        </div>
        <p className="text-xs text-gray-500 text-center">
          Download a processed copy, or write the room allocations and any standardised teacher
          names straight back into the workbook you uploaded
        </p>
      </div>
    </div>
  );
};

export default ProcessingControls;
